import React, { useEffect, useMemo, useState } from 'react';
import { Animated, Button, Platform, Pressable, StyleSheet, Text, View, useWindowDimensions, } from 'react-native';
import { Appbar, TextInput } from 'react-native-paper';
import { Dropdown } from 'react-native-paper-dropdown';
import { Glyph } from '../components/Glyph';
import { shadowStyle } from '../components/styles';
import { UserActivityType, UserEventType } from '../types/userEvent.interface.d';
import { activityTypeToString } from './userEventViewModel';
import { theme } from '../theme';
const OPTIONS = [
    {
        label: activityTypeToString(UserActivityType.reg),
        value: `${UserActivityType.reg}`,
    },
    {
        label: activityTypeToString(UserActivityType.coaching),
        value: `${UserActivityType.coaching}`,
    },
    {
        label: activityTypeToString(UserActivityType.referral),
        value: `${UserActivityType.referral}`,
    },
    {
        label: activityTypeToString(UserActivityType.success),
        value: `${UserActivityType.success}`,
    },
    {
        label: activityTypeToString(UserActivityType.other),
        value: `${UserActivityType.other}`,
    },
];
const MenuDownIcon = () => <Glyph name="arrow_drop_down"/>;
const MenuUpIcon = () => <Glyph name="arrow_drop_up"/>;
function CustomMenuHeader(props) {
    const style = useMemo(() => ({ borderTopRightRadius: 4, borderTopLeftRadius: 4 }), []);
    return (<Appbar.Header statusBarHeight={0} style={style}>
      <Appbar.Content title={props.label}/>
    </Appbar.Header>);
}
export const NoteSidePanel = ({ visible, byUser, forUser, onSave, onCancel, onAnimationComplete, fullScreen = false, }) => {
    const { width: windowWidth } = useWindowDimensions();
    const hiddenOffset = fullScreen ? windowWidth : 300;
    const slideAnim = useMemo(() => new Animated.Value(hiddenOffset), 
    // Start off-screen once; later closes animate to the current offset.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    const [activityType, setActivityType] = useState();
    const [note, setNote] = useState();
    useEffect(() => {
        Animated.timing(slideAnim, {
            toValue: visible ? 0 : hiddenOffset,
            duration: 300,
            useNativeDriver: Platform.OS !== 'web',
        }).start(() => {
            // When closing animation is complete, notify parent
            if (!visible) {
                onAnimationComplete();
            }
        });
    }, [visible, slideAnim, onAnimationComplete, hiddenOffset]);
    return (<Animated.View style={[
            styles.sidePanel,
            fullScreen && styles.fullScreen,
            { transform: [{ translateX: slideAnim }] },
        ]} testID="note-panel">
      <View style={[styles.panelHeader, fullScreen && styles.headerRow]}>
        <Text style={[styles.panelTitle, fullScreen && styles.titleFlex]}>
          Adding note for {forUser.firstName}
        </Text>
        {fullScreen ? (<Pressable onPress={onCancel} style={styles.closeHit} accessibilityRole="button" accessibilityLabel="Close note">
            <Glyph name="close" size={22} color={theme.colors.textCaption}/>
          </Pressable>) : null}
      </View>
      <Dropdown mode="outlined" label="Activity Type" placeholder="Select Activity Type" options={OPTIONS} value={activityType} onSelect={setActivityType} menuUpIcon={<TextInput.Icon icon={MenuUpIcon} style={styles.iconPointerEventsNone}/>} menuDownIcon={<TextInput.Icon icon={MenuDownIcon} style={styles.iconPointerEventsNone}/>} CustomMenuHeader={CustomMenuHeader}/>

      <TextInput style={[styles.noteInput, fullScreen && styles.noteInputPhone]} placeholder="Enter your note..." multiline dense mode="outlined" value={note} onChangeText={t => setNote(t)}/>

      <View style={styles.noteButtonsContainer}>
        <Button title="Save" onPress={() => onSave({
            eventType: UserEventType.note,
            activityType: activityType,
            byUserId: byUser.id,
            forUserId: forUser.id,
            note,
        })}/>
        <Button title="Cancel" onPress={onCancel}/>
      </View>
    </Animated.View>);
};
const styles = StyleSheet.create({
    sidePanel: {
        position: 'absolute',
        right: 0,
        top: 0,
        bottom: 60,
        width: 300,
        backgroundColor: theme.colors.surfaceElevated,
        padding: 20,
        ...shadowStyle(-3, 0, 10, 0.3),
    },
    fullScreen: {
        left: 0,
        bottom: 0,
        width: '100%',
        padding: 16,
        zIndex: 20,
    },
    headerRow: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    titleFlex: { flex: 1 },
    closeHit: {
        minWidth: 44,
        minHeight: 44,
        alignItems: 'center',
        justifyContent: 'center',
    },
    noteInputPhone: {
        height: 140,
        marginVertical: 12,
    },
    panelHeader: {
        fontSize: 18,
        fontWeight: 'bold',
        marginBottom: 10,
    },
    panelTitle: {
        fontSize: 18,
        fontWeight: 'bold',
    },
    noteInput: {
        marginVertical: 20,
        padding: 10,
        height: 500,
    },
    noteButtonsContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    iconPointerEventsNone: { pointerEvents: 'none' },
});
